import { createSlice } from "@reduxjs/toolkit";
import {
  getAllAnalyticsCounts,
  getAnalytics,
  getAnalyticsShopDetails,
} from "./analyticsThunk";

const initialState = () => ({
  analyticsLoading: false,
  analyticsData: [],
  analyticsDataCount: 0,
  analyticsCardStates: {},
  analyticsTableData: {},
});

const analyticsSlice = createSlice({
  initialState: initialState(),
  name: "analytics",
  reducers: {},
  extraReducers: (builder) => {
    //get All Analytics Counts
    builder
      .addCase(getAllAnalyticsCounts.pending, (state, { payload }) => {
        state.analyticsLoading = true;
      })
      .addCase(getAllAnalyticsCounts.fulfilled, (state, { payload }) => {
        state.analyticsLoading = false;
        state.analyticsCardStates = payload?.data;
      })
      .addCase(getAllAnalyticsCounts.rejected, (state, { payload }) => {
        state.analyticsLoading = false;
      });
    //get analytics
    builder
      .addCase(getAnalytics.pending, (state, { payload }) => {
        state.analyticsLoading = true;
      })
      .addCase(getAnalytics.fulfilled, (state, { payload }) => {
        state.analyticsLoading = false;
        state.analyticsData = payload?.data?.rows;
        state.analyticsDataCount = payload?.data?.count;
      })
      .addCase(getAnalytics.rejected, (state, { payload }) => {
        state.analyticsLoading = false;
      });
    builder
      .addCase(getAnalyticsShopDetails.pending, (state) => {
        state.analyticsLoading = true;
      })
      .addCase(getAnalyticsShopDetails.fulfilled, (state, { payload }) => {
        state.analyticsLoading = false;
        state.analyticsTableData = payload?.data;
      })
      .addCase(getAnalyticsShopDetails.rejected, (state) => {
        state.analyticsLoading = false;
      });
  },
});

export default analyticsSlice.reducer;
